import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import TopNavbar from '../Nav/TopNavbar';
import Footer from './Footer';

export default function TrialThankYouPage() {
  const { state } = useLocation();
  const navigate  = useNavigate();

  const downloadUrl  = state?.download_url || '';
  const licenseKey   = state?.license_key  || '';

  /* if user visits page directly without context → back to home */
  useEffect(() => {
    if (!downloadUrl) navigate('/');
  }, [downloadUrl, navigate]);

  return (
    <>
      <TopNavbar returnTo={false} />

      <Wrapper>
        <h2>🎉 Your trial is ready!</h2>

        <p>
          We’ve emailed you a download link and your trial license key.  
          <br />
          <strong>Please check your inbox</strong> (and spam folder just in
          case).
        </p>

        {!!licenseKey && (
          <p className="license">
            <strong>Trial License&nbsp;Key:</strong> {licenseKey}
          </p>
        )}

        {downloadUrl && (
          <a
            className="download-btn"
            href={downloadUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Download Now
          </a>
        )}
        <br/>

        <BackHome onClick={() => navigate('/')}>Back to Home</BackHome>
      </Wrapper>

      <Footer />
    </>
  );
}

/* ───────── styled-components ───────── */
const Wrapper = styled.div`
  max-width: 600px;
  margin   : 60px auto;
  padding  : 30px 26px;
  border   : 1px solid #ddd;
  border-radius: 12px;
  text-align: center;
  background: #fff;

  h2 { margin-bottom: 18px; }

  p  { margin: 10px 0; }

  .license {
    background: #f5f5f5;
    padding: 10px;
    border-radius: 6px;
    word-break: break-all;
  }

  .download-btn {
    display: inline-block;
    margin: 22px 0 12px;
    padding: 12px 28px;
    background: #6c2bd9;
    color: #fff;
    border-radius: 6px;
    font-weight: 600;
    text-decoration: none;
  }

  .download-btn:hover { background: #5e2a84; }
`;

const BackHome = styled.button`
  border: none;
  background: transparent;
  color: #6c2bd9;
  cursor: pointer;
  text-decoration: underline;
  margin-top: 10px;
`;
